import { render, staticRenderFns } from "./NewCountryComponent.vue?vue&type=template&id=67624258"
import script from "./NewCountryComponent.vue?vue&type=script&lang=js"
export * from "./NewCountryComponent.vue?vue&type=script&lang=js"
import style0 from "./NewCountryComponent.vue?vue&type=style&index=0&id=67624258&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports